import { useEffect } from 'react';

interface ZendeskProps {
  load?: boolean;
}

export default function Zendesk({ load = true }: ZendeskProps) {
  useEffect(() => {
    if (!load) return;

    if (document.getElementById('ze-snippet')) return;

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src =
      'https://static.zdassets.com/ekr/snippet.js?key=f58fc6d8-1697-4d35-9d24-ac5729d16a30';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [load]);

  return null;
}
